import { createFileRoute } from "@tanstack/react-router";

import { GdprRequestsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/gdpr")({
  component: GdprRequestsPage,
});
